/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { SupplierAttribute } from './SupplierAttribute'
import {
  SupplierAttributeFromJSON,
  SupplierAttributeFromJSONTyped,
  SupplierAttributeToJSON,
  SupplierAttributeToJSONTyped,
} from './SupplierAttribute'

/**
 *
 * @export
 * @interface Supplier
 */
export interface Supplier {
  /**
   *
   * @type {string}
   * @memberof Supplier
   */
  id: string
  /**
   * IIN or BIN of supplier. See more https://egov.kz/cms/ru/articles/iin_info | https://ru.wikipedia.org/wiki/%D0%98%D0%BD%D0%B4%D0%B8%D0%B2%D0%B8%D0%B4%D1%83%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9_%D0%B8%D0%B4%D0%B5%D0%BD%D1%82%D0%B8%D1%84%D0%B8%D0%BA%D0%B0%D1%86%D0%B8%D0%BE%D0%BD%D0%BD%D1%8B%D0%B9_%D0%BD%D0%BE%D0%BC%D0%B5%D1%80
   * @type {string}
   * @memberof Supplier
   */
  uid: string
  /**
   *
   * @type {string}
   * @memberof Supplier
   */
  title: string
  /**
   *
   * @type {number}
   * @memberof Supplier
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof Supplier
   */
  updatedAt: number
  /**
   *
   * @type {Array<SupplierAttribute>}
   * @memberof Supplier
   */
  attributes?: Array<SupplierAttribute>
}

/**
 * Check if a given object implements the Supplier interface.
 */
export function instanceOfSupplier(value: object): value is Supplier {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('uid' in value) || value['uid'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function SupplierFromJSON(json: any): Supplier {
  return SupplierFromJSONTyped(json, false)
}

export function SupplierFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Supplier {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    uid: json['uid'],
    title: json['title'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
    attributes:
      json['attributes'] == null
        ? undefined
        : (json['attributes'] as Array<any>).map(SupplierAttributeFromJSON),
  }
}

export function SupplierToJSON(json: any): Supplier {
  return SupplierToJSONTyped(json, false)
}

export function SupplierToJSONTyped(
  value?: Supplier | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    uid: value['uid'],
    title: value['title'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
    attributes:
      value['attributes'] == null
        ? undefined
        : (value['attributes'] as Array<any>).map(SupplierAttributeToJSON),
  }
}
